export default "__VITE_ASSET__BcqVmYU0__"